module.exports = __webpack_public_path__ + "img/autospin_btn.5b623184.png";